import brazil_quote_card from './brazil_quote_card';
import brazil_quote_cards_section from './brazil_quote_cards_section';
import brazil_form from './brazil_form';
import brazil_back_button from './brazil_back_button';
import lgpd_identity_verification from './lgpd_identity_verification';
import submit_button from './submit_button';
import quote_slider from './quote_slider';
import quote_details from './quote_details';
import loan_status_table_row from './loan_status_table_row';
import loan_status_table_final_row from './loan_status_table_final_row';
import loan_status_timeline_row from './loan_status_timeline_row';
import loan_status_modal from './loan_status_modal';
import phone_verification from './phone_verification';
import ebs_loading from './ebs_loading';

export default {
  brazil_quote_card,
  brazil_quote_cards_section,
  quote_details,
  brazil_form,
  brazil_back_button,
  lgpd_identity_verification,
  submit_button,
  quote_slider,
  loan_status_table_row,
  loan_status_table_final_row,
  loan_status_timeline_row,
  loan_status_modal,
  phone_verification,
  ebs_loading,
};
